import * as actions from './actionTypes';

const initialState = {
  profiles: undefined,
  selectProfile: undefined,
  saveProfileAgeRating: undefined,
  saveProfileName: undefined,
};

export default function profileReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.CREATE_PROFILE:
    case actions.DELETE_PROFILE:
    case actions.EDIT_PROFILE:
    case actions.GET_PROFILES: {
      return {
        ...state,
        profiles: action.payload,
      };
    }

    case actions.GET_SELECT_PROFILE: {
      return state;
    }

    case actions.SET_SELECT_PROFILE: {
      return {
        ...state,
        selectProfile: action.payload,
      };
    }

    case actions.LOGIN_SUCCESS: {
      return {
        ...state,
      };
    }

    case actions.SAVE_PROFILE_AGE_RATING: {
      return {
        ...state,
        saveProfileAgeRating: action.payload,
      };
    }

    case actions.SAVE_PROFILE_NAME: {
      return {
        ...state,
        saveProfileName: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
